(() => {
  // U4 — AJAX repaint for color swatches.
  // On click of a non-active sibling swatch, fetch the target product's section
  // markup via Shopify Section Rendering API and swap it in place.
  const SECTIONS = ['main-product'];

  function swapSection(html, sectionId) {
    const el = document.getElementById(`shopify-section-${sectionId}`);
    if (!el) return false;
    const fresh = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(`#shopify-section-${sectionId}`);
    if (!fresh) return false;
    el.replaceWith(fresh);
    return true;
  }

  document.addEventListener('click', async (e) => {
    const link = e.target.closest('.color-swatches__swatch');
    if (!link) return;
    if (link.classList.contains('is-active')) { e.preventDefault(); return; }
    const url = link.dataset.productUrl;
    if (!url) return;
    e.preventDefault();
    try {
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(`${url}${sep}sections=${SECTIONS.join(',')}`, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) { window.location = url; return; }
      const payload = await res.json();
      let swappedAny = false;
      SECTIONS.forEach(id => {
        if (payload[id]) {
          if (swapSection(payload[id], id)) swappedAny = true;
        }
      });
      if (!swappedAny) { window.location = url; return; }
      history.pushState({}, '', url);
      window.scrollTo({ top: 0, behavior: 'instant' });
      document.dispatchEvent(new CustomEvent('shevchenko:color-swapped', { detail: { url } }));
    } catch (err) {
      // Network failure → graceful fallback to full nav
      window.location = url;
    }
  });

  // Handle browser back/forward — re-fetch and swap so user sees consistent state
  window.addEventListener('popstate', async () => {
    try {
      const url = location.pathname + location.search;
      if (!/\/products\//.test(url)) return; // not a PDP
      const sep = url.includes('?') ? '&' : '?';
      const res = await fetch(`${url}${sep}sections=${SECTIONS.join(',')}`, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });
      if (!res.ok) return;
      const payload = await res.json();
      SECTIONS.forEach(id => { if (payload[id]) swapSection(payload[id], id); });
    } catch {}
  });
})();
